import apiClient from '../apiClient';

export const checkRequest = async (authToken: string, brandCode: string, currentUrl: string) => {
    try {
        const response = await apiClient(`/widget/check_request`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
            body: JSON.stringify({
                partner_id: brandCode,
                request_url: currentUrl,
            }),
        });

        return response;  // boolean
    } catch (error: any) {
        console.error("error in checkRequest: ", error.message);
    }
};
